import * as React from 'react';

import Content from 'bundles/widget-simulator/components/Content';
import PageHeader from 'bundles/widget-simulator/components/PageHeader';
import Sidebar from 'bundles/widget-simulator/components/Sidebar';

import 'css!./__styles__/RootPage';

class RootPage extends React.Component {
  render() {
    return (
      <div className="rc-RootPage">
        <PageHeader />
        <div className="root-page-body horizontal-box">
          <Sidebar />
          <Content />
        </div>
      </div>
    );
  }
}

export default RootPage;
